export const COMPANY_SIZE_OPTIONS = [
  { value: '1-10', label: '1 - 10' },
  { value: '11-50', label: '11 - 50' },
  { value: '51-200', label: '51 - 200' },
  { value: '201-500', label: '201 - 500' },
  { value: '500+', label: '500+' },
];

export const INDUSTRY_OPTIONS = [
  { value: 'Aerospace & Defense', label: '航空航天与国防' },
  { value: 'Agriculture & Food', label: '农业与食品' },
  {
    value: 'Automotive & Transportation',
    label: '汽车与交通',
  },
  { value: 'Chemicals & Materials', label: '化工与材料' },
  {
    value: 'Construction & Built Environment',
    label: '建筑与工程',
  },
  {
    value: 'Consumer Packaged Goods (CPG)',
    label: '消费品',
  },
  { value: 'Education', label: '教育培训' },
  { value: 'Entertainment', label: '文娱传媒' },
  { value: 'Finance', label: '金融服务' },
  { value: 'Government & Nonprofit', label: '政府与公益组织' },
  { value: 'Healthcare', label: '医疗健康' },
  { value: 'Hospitality & Tourism', label: '酒店与旅游' },
  { value: 'Industrial & Energy', label: '工业与能源' },
  { value: 'Legal & Compliance', label: '法律与合规' },
  { value: 'Lifestyle & Leisure', label: '生活服务' },
  { value: 'Logistics & Supply Chain', label: '物流与供应链' },
  { value: 'Luxury & Fashion', label: '奢侈品与时尚' },
  { value: 'News & Media', label: '新闻与媒体' },
  {
    value: 'Professional Services & Agencies',
    label: '专业服务与代理机构',
  },
  { value: 'Real Estate & PropTech', label: '房地产与物业科技' },
  { value: 'Retail & E-commerce', label: '零售与电商' },
  { value: 'Sports', label: '体育' },
  { value: 'Technology', label: '科技互联网' },
  { value: 'Telecommunications', label: '通信服务' },
  { value: 'Other', label: '其他' },
];

export const REFERRAL_SOURCE_OPTIONS = [
  { value: 'google', label: '搜索引擎' },
  { value: 'reddit', label: '社区平台' },
  { value: 'twitter', label: '社交媒体' },
  { value: 'linkedin', label: '商务社交平台' },
  { value: 'friend', label: '朋友或同事推荐' },
  { value: 'blog', label: '文章或博客' },
  { value: 'github', label: '开源社区' },
  { value: 'other', label: '其他' },
];

export const USER_ROLE_OPTIONS = [
  { value: 'founder', label: '创始人/负责人' },
  { value: 'product_manager', label: '产品经理' },
  { value: 'engineering', label: '技术/研发' },
  { value: 'support_lead', label: '客服负责人' },
  { value: 'marketing', label: '市场运营' },
  { value: 'sales', label: '销售' },
  { value: 'other', label: '其他' },
];
